import React, {useState, useEffect} from 'react';
import { useParams, Redirect } from "react-router-dom";

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import httpClient from '../fetch/fetch';
import {toast} from "react-toastify"
import moment from 'moment/moment';

import { atcb_action } from 'add-to-calendar-button';
import 'moment/locale/es';
import Loader, { generarCabeceraHTML } from './helpers/Loader';
import ModalTermsContent from './helpers/ModalTermsContent';
import Select from 'react-select'
var daysopt = [
    {label: "SELECCIONA UNA OPCION", value: ""},
    {label: "Seminario del 13 de junio", value: "1"},
    {label: "Seminario del 14 de junio", value: "2"},
    {label: "Ambas fechas", value: "3"},
];

// const EVENTO_ID_PERMITIR_SIN_RUC = 0; //Antes:56 | 59 (piura) | 

moment.locale('es');

function FormRegister() {
    const params = useParams();
    //const history = useHistory();
    const {slug} = params;

    const [loading, setloading] = useState(true);
    const [sending, setsending] = useState(false);
    const [success, setsuccess] = useState(false);

    const [event, setevent]     = useState({});
    const [errors, seterrors]   = useState({});

    const [slugNotFound, setslugNotFound] = useState(false);

    const [ruc, setruc] = useState('');
    const [razon_social, setrazon_social] = useState('');
    const [nombre, setnombre] = useState('');
    const [lastname, setlastname] = useState('');
    const [phone, setphone] = useState('');
    const [email, setemail] = useState('');

    const [accept, setaccept] = useState(true);

    //const [edet_AsistDia1 , setedet_AsistDia1 ] = useState(false);
    //const [edet_AsistDia2,  setedet_AsistDia2]  = useState(false);

    const [asist, setasist] = useState(daysopt[0]);

    const [show, setshow] = useState(false);

    const [btnCalendar, setbtnCalendar] = useState("");

    const handleClose = () => {
        setshow(false);
    }

    const sendRegister = (e) => {
        e.preventDefault();

        let errors = {};
        let errorsCount = 0;
        seterrors(errors);
     
        // if (event.even_Id > EVENTO_ID_PERMITIR_SIN_RUC) //I Foro Internacional de Diversificación Exportadora 
        if (ruc.trim() !== "") 
        {
            if(ruc.length!==11){
                errors['ruc'] = "Ingrese un ruc completo";
                // toast.error("Debe ingresar su ruc");
                errorsCount++;
            }
    
            if(razon_social === ""){
                errors['razon_social'] = "Debe ingresar una razón social";
                errorsCount++;
            }
        }

        if (razon_social.trim() !== "" && ruc.trim() === "")
        {
            errors['ruc'] = "Ingrese un ruc válido";
            errorsCount++;
        }

        if(nombre === ""){
            errors['nombre'] = "Debe ingresar su nombre";
            // toast.error("Debe ingresar un nombre");
            errorsCount++;
        }

        if(lastname === ""){
            errors['lastname'] = "Debe ingresar su apellido";
            // toast.error("Debe ingresar su apellido");
            errorsCount++;
        }

        if(phone === ""){
            errors['phone'] = "Debe ingresar su teléfono";
            // toast.error("Debe ingresar su teléfono");
            errorsCount++;
        }

        if(email === ""){
            errors['email'] = "Debe ingresar su email";
            // toast.error("Debe ingresar su email");
            errorsCount++;
        }

        if(accept === "" || accept === false){
            errors['accept'] = "Debe aceptar la política de datos personales";
            // toast.error("Debe ingresar su email");
            errorsCount++;
        }

        if(event.even_AsistPorDia){
            if(!asist || (asist && asist.value === "")){
                errors['asist'] = "Debe seleccionar una fecha";
                errorsCount++;
            }
        }
       

        if(errorsCount > 0){
            //toast.error("Se han encontrado errores en el formulario");
            console.log(errors);
            seterrors(errors);
            setsending(false);

        }else{
            seterrors({});
            //setsending(true);
            setsending(true);

            // Hardcode permanente 2025.julio jorge@expr
            let vRuc = ruc.trim();
            let vRazon = razon_social.trim();
            if (vRuc === "") //I Foro Internacional de Diversificación Exportadora 
            {
                 vRuc = ruc.trim() === "" ? "20000000000" : ruc.trim();
                 vRazon = razon_social.trim() === "" ? "." : razon_social.trim();
            }

            let dataForm = {
                Even_Id: event.even_Id,

                Edet_TipoDocumento:     "R",
                Edet_NumeroDocumento:   vRuc,
                Edet_RazonSocial:       vRazon,

                Edet_Nombre:            nombre.trim(),
                Edet_Apellidos:         lastname.trim(),

                Edet_Telefono:          phone,
                Edet_Email:             email.trim(),

                Edet_TerminoCondicion:  accept,
                Edet_CompartirDatos:    false // Campo retirado de la UI; se conserva en el payload por compatibilidad con el backend
            }

            if(event.even_AsistPorDia){
                // dataForm.edet_AsistDia1 = edet_AsistDia1;
                // dataForm.edet_AsistDia2 = edet_AsistDia2;

                if(asist.value === '1'){
                    dataForm.edet_AsistDia1 = true;
                    dataForm.edet_AsistDia2 = false;
                }else if(asist.value === '2'){
                    dataForm.edet_AsistDia1 = false;
                    dataForm.edet_AsistDia2 = true;
                }else if(asist.value === '3'){
                    dataForm.edet_AsistDia1 = true;
                    dataForm.edet_AsistDia2 = true;
                }
            }

            //console.log(dataForm);
            const url = `api/Evento/RegistrarUsuarioEvento`;
            httpClient.post(url, dataForm)
            .then((res) => {

                const evento = res.data.evento;

                httpClient.get(`api/Evento/ObtenerParametroPorCodigo?codigo=RSM`)
                .then((res) => {
                    if(res.status = 200){
                        const dataTemplate = res.data;

                        let dataevent = {};
                        dataevent.nombre        = event.even_Nombre;
                        dataevent.description   = event.even_Descripcion;

                        dataevent.templatemsg   = dataTemplate.find((item) => item.codigo === 'RSM')['valor'];
                        dataevent.msg           = dataevent.templatemsg.replace('{{NombreEvento}}', dataevent.nombre);
                        
                        // console.log(dataevent);
                        localStorage.setItem("title", event.even_Descripcion ? event.even_Descripcion : event.Even_Nombre);
                        // localStorage.setItem("img", event.even_ImagenBanner ? event.even_ImagenBanner : "");
                        localStorage.setItem("img", event.even_LogoEvento ? event.even_LogoEvento : "");
                        localStorage.setItem("msg", dataevent.msg);
                        localStorage.setItem("fechaInicio", moment(event.even_FechaInicio).format('D [de] MMMM [de] YYYY'));
                        localStorage.setItem("horaInicio", moment(event.even_FechaInicio).format('HH:mm [h]'));
                        localStorage.setItem("btnCalendar", evento.even_BotonAgregarCalendar);
                        localStorage.setItem("cabecera", generarCabeceraHTML(false, event) );
                        
                        window.location.href = "/eventos/registro-exitoso.html"
                    }

                }).catch((err) => {
                    setsending(false);
                });

            }).catch((err) => {

                 if (ruc==="") //I Foro In
                 {
                     if (ruc==="20000000000") { setruc("")  }
                     if (razon_social===".") { setrazon_social("")  }
                 }

                if(err.response){
                    // let data = err.response.data;
                    let errorsred = err.response.data.error_messages;
                    let newErrors = {};

                    if(errorsred.length > 0){
                        // console.log(errorsred);
                        errorsred.map((item) => {
                            // toast.error(item.message);
                            newErrors[item.field] = item.message;
                        });

                        // console.log(newErrors);
                        seterrors(newErrors);
                    }

                    console.error(errorsred);
                }

                setsending(false);
            });

            /*
                const databtnCalendar = res.data.evento.even_BotonAgregarCalendar;
                    let textbtn     = databtnCalendar.split("<script>");

                    setbtnCalendar(databtnCalendar);
                    setsending(false);
                    setsuccess(true);

                    setTimeout(() => {
                        var script      = document.createElement("script");
                        let functions   = textbtn[1].toString().split("</");
                        script.id       = "btnCalendarSource";
                        script.innerHTML = functions[0];

                        document.he ad.appendChild(script);
                    }, 100);
                */
                // redirect(`/registro/${slug}/resultado`);
        }

    }

    const getDataBySlug = () => {
        const {slug} = params;
        if(slug !== ""){
            setloading(true);

            httpClient.get(`api/Evento/ObtenerEventoPorUrl/${slug}`)
            .then((res) => {
                // console.log(res.data);

                if(res.status = 200){
                    setevent(res.data);
                    setloading(false);
                }
            }).catch((err) => {
                setslugNotFound(true);
                setloading(false);
            });
        }else{
            setslugNotFound(true);
            setloading(false);
        }
    }

    const { even_LogoEvento, even_ImagenBanner, even_Nombre } = event;
    const mostrarCabeceraEspecial = even_LogoEvento && even_LogoEvento !== "";

    useEffect(() => {
        if(loading){
            getDataBySlug();
            document.title = 'Registro para eventos';
        }
    }, [loading]);
    
    if(!loading && !success){
        // console.log(EVENTO_ID_PERMITIR_SIN_RUC === event.even_Id ? "SIN RUC" : "CON RUC")

        return (
            <div>
                <header className='header-page'>
                    <div className="container text-center">
                        <div className="row justify-content-center align-items-center">
                            {!slugNotFound && event && (
                                mostrarCabeceraEspecial ? (
                                    <div className="col-lg-7"
                                        dangerouslySetInnerHTML={{ __html: generarCabeceraHTML(false, event) }} 
                                    />
                                ) : (
                                    <div className="col-lg-7">
                                        <img src={event.even_ImagenBanner} alt={event.even_Nombre} className="img-fluid" />
                                    </div>
                                )
                            )}
                            </div>
                    </div>
                </header>

                <section className="formulario registro">
                    <Modal show={show} onHide={handleClose} animation={false} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title className='fw-bold'>
                                Política de Datos Personales
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className='modal-content-scroll'>
                            <div className="f-normal">
                                <ModalTermsContent />
                            </div>
                        </Modal.Body>
                        <Modal.Footer className='f-normal'>
                            <Button variant="secondary" onClick={handleClose}>
                                Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    { !slugNotFound &&
                        <div className="content">
                            <div className="container">
                                <div className="row justify-content-center pt-4">
                                    <div className="col-lg-6 image px-0 d-none">
                                        <div className="px-5 header-data d-flex align-items-center justify-content-between">
                                            <a href="/" className="back">
                                                <img src="/images/back.svg" className='me-3' alt="" /> 
                                                Regresar
                                            </a>
                                            <div>
                                                <img src="/images/logos-formularios.svg" alt="" />
                                            </div>
                                        </div>
                                        <img src="/images/banner.jpg" className='img-banner' alt="" />
                                    </div>
                                    <div className="col-lg-7 d-flex align-items-center">
                                        <div className="form-content w-100 card shadow">
                                            <div className="card-body">
                                                <div className="container w-100 py-4">
                                                    <h2 className='title'>Regístrese</h2>
                                                    <p className='subtitle pb-4'>
                                                        {event.even_Descripcion ? event.even_Descripcion : event.Even_Descripción}
                                                    </p>

                                                    <form onSubmit={(e) => sendRegister(e)} className='px-lg-5'>
                                                        <div className="row">
                                                            <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                                <label htmlFor="UsuarioRuc">RUC</label>
                                                                <input 
                                                                    className={((errors.hasOwnProperty('ruc') || errors.hasOwnProperty('Edet_NumeroDocumento')) ? "hasError " : "") + `form-control soloNumeros`} 
                                                                    id="usuarioRuc" 
                                                                    name="UsuarioRuc"  
                                                                    type="number" 
                                                                    // defaultValue={ruc}
                                                                    value={ruc}
                                                                    onChange={(e) => (e.target.value.length <= 11) ? setruc(e.target.value) : false}
                                                                    // onChange={(e) => setruc(e.target.value)} 
                                                                    
                                                                />
                                                                {(errors.hasOwnProperty('ruc') || errors.hasOwnProperty('Edet_NumeroDocumento')) && 
                                                                    <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                        {errors.ruc ? errors.ruc : ""}
                                                                        {errors.Edet_NumeroDocumento ? errors.Edet_NumeroDocumento : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                                <label htmlFor="UsuarioRazonSocial">Razón Social</label>
                                                                <input 
                                                                    className={((errors.hasOwnProperty('razon_social') || errors.hasOwnProperty('Edet_RazonSocial')) ? "hasError " : "") + `form-control`} 
                                                                    id="UsuarioRazonSocial" 
                                                                    name="UsuarioRazonSocial"  
                                                                    type="text" 
                                                                    defaultValue={razon_social}
                                                                    onChange={(e) => setrazon_social(e.target.value)} 
                                                                />
                                                                {(errors.hasOwnProperty('razon_social') || errors.hasOwnProperty('Edet_RazonSocial')) && 
                                                                    <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                        {errors.razon_social ? errors.razon_social : ""}
                                                                        {errors.Edet_RazonSocial ? errors.Edet_RazonSocial : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                                <label htmlFor="UsuarioNombres">Nombre*</label>
                                                                <input 
                                                                    className={((errors.hasOwnProperty('nombre') || errors.hasOwnProperty('Edet_Nombre')) ? "hasError " : "") + `form-control`}  
                                                                    data-val="true" 
                                                                    data-val-required="Este campo es obligatorio" 
                                                                    id="UsuarioNombres" 
                                                                    maxLength={50} 
                                                                    name="UsuarioNombres" 
                                                                    type="text" 
                                                                    defaultValue={nombre}
                                                                    onChange={(e) => setnombre(e.target.value)} 
                                                                />
                                                                {(errors.hasOwnProperty('nombre') || errors.hasOwnProperty('Edet_Nombre')) && 
                                                                    <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                        {errors.nombre ? errors.nombre : ""}
                                                                        {errors.Edet_Nombre ? errors.Edet_Nombre : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                                <label htmlFor="UsuarioApellidos">Apellidos*</label>
                                                                <input 
                                                                    className={((errors.hasOwnProperty('lastname') || errors.hasOwnProperty('Edet_Apellidos')) ? "hasError " : "") + `form-control`}   
                                                                    id="UsuarioApellidos"
                                                                    maxLength={50} 
                                                                    name="UsuarioApellidos"  
                                                                    type="text" 
                                                                    defaultValue={lastname}
                                                                    onChange={(e) => setlastname(e.target.value)} 
                                                                />
                                                                {(errors.hasOwnProperty('lastname') || errors.hasOwnProperty('Edet_Apellidos')) && 
                                                                    <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                        {errors.lastname ? errors.lastname : ""}
                                                                        {errors.Edet_Apellidos ? errors.Edet_Apellidos : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                                <label htmlFor="UsuarioTelefono">Teléfono Móvil*</label>
                                                                <input 
                                                                    className={((errors.hasOwnProperty('phone') || errors.hasOwnProperty('Edet_Telefono')) ? "hasError " : "") + `form-control`}
                                                                    id="UsuarioTelefono" 
                                                                    
                                                                    name="UsuarioTelefono" 
                                                                    type="number" 
                                                                    // defaultValue={phone}
                                                                    value={phone}
                                                                    onChange={(e) => (e.target.value.length <= 9) ? setphone(e.target.value) : false}
                                                                />
                                                                {(errors.hasOwnProperty('phone') || errors.hasOwnProperty('Edet_Telefono')) && 
                                                                    <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                        {errors.phone ? errors.phone : ""}
                                                                        {errors.Edet_Telefono ? errors.Edet_Telefono : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-lg-6 col-12 col-sm-6 mb-4">
                                                                <label htmlFor="UsuarioCorreoElectronico">Correo Electrónico*</label>
                                                                <input 
                                                                    className={((errors.hasOwnProperty('email') || errors.hasOwnProperty('Edet_Email')) ? "hasError " : "") + `form-control`}
                                                                    id="UsuarioCorreoElectronico" 
                                                                    maxLength={120} 
                                                                    name="UsuarioCorreoElectronico" 
                                                                    type="text" 
                                                                    defaultValue={email}
                                                                    onChange={(e) => setemail(e.target.value)} 
                                                                />
                                                                {(errors.hasOwnProperty('email') || errors.hasOwnProperty('Edet_Email')) && 
                                                                    <div className='small text-primary fw-bold pt-2' style={{fontSize: '.6em'}}>
                                                                        {errors.email ? errors.email : ""}
                                                                        {errors.Edet_Email ? errors.Edet_Email : ""}
                                                                    </div>
                                                                }
                                                            </div>
                                                            {event.even_AsistPorDia &&
                                                                <div className="col-lg-12 col-12 col-sm-6 mb-4 react-select-container-styles">
                                                                    <label htmlFor="asist" className='mb-1'>
                                                                        Confirmar las fechas a las que asistirá:
                                                                    </label>
                                                                    <Select
                                                                        id='asist'
                                                                        options={daysopt}
                                                                        // defaultInputValue=''
                                                                        value={asist}
                                                                        onChange={(val) => setasist(val)}
                                                                        placeholder="SELECCIONA UNA OPCIÓN"
                                                                        // isClearable
                                                                    />
                                                                    {errors.hasOwnProperty('asist') && 
                                                                        <div className='small text-primary fw-bold pt-2 pb-3' style={{fontSize: '.6em'}}>
                                                                            {errors.asist ? errors.asist : ""}
                                                                            {
                                                                                // errors.Edet_Email ? errors.Edet_Email : ""
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }

                                                            {/* 
                                                            <div className="col-lg-6 mb-3">
                                                                <label htmlFor="UsuarioNumeroDocumento">Número de Documento*</label>
                                                                <input 
                                                                    className="form-control" 
                                                                    id="UsuarioNumeroDocumento" 
                                                                    maxLength={12} 
                                                                    name="UsuarioNumeroDocumento" 
                                                                    onkeypress="return valideKey(event)" 
                                                                    required="required" 
                                                                    type="text" 
                                                                    defaultValue=""
                                                                />
                                                            </div>
                                                            */}
                                                        </div>

                                                        {/*event.even_AsistPorDia &&
                                                            <div>
                                                                <div className="custom-control custom-checkbox pt-4">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        className="custom-control-input" 
                                                                        name="UsuarioAceptoTerminos" 
                                                                        id="edet_AsistDia1" 
                                                                        checked={edet_AsistDia1}
                                                                        onChange={() => setedet_AsistDia1(!edet_AsistDia1)}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor="edet_AsistDia1">
                                                                        Quiero asistir el día 1
                                                                    </label>
                                                                </div>

                                                                <div className="custom-control custom-checkbox pt-2">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        className="custom-control-input" 
                                                                        name="UsuarioAceptoTerminos" 
                                                                        id="edet_AsistDia2" 
                                                                        checked={edet_AsistDia2}
                                                                        onChange={() => setedet_AsistDia2(!edet_AsistDia2)}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor="edet_AsistDia2">
                                                                        Quiero asistir el día 2
                                                                    </label>
                                                                </div>

                                                                {errors.hasOwnProperty('asist') && 
                                                                    <div className='small text-primary fw-bold pt-2 pb-3' style={{fontSize: '.6em'}}>
                                                                        {errors.asist ? errors.asist : ""}
                                                                        {
                                                                            // errors.Edet_Email ? errors.Edet_Email : ""
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                        */}

                                                        <div className="custom-control custom-checkbox pt-2">
                                                            <input 
                                                                type="checkbox" 
                                                                className="custom-control-input" 
                                                                name="UsuarioAceptoTerminos" 
                                                                id="tyc" 
                                                                checked={accept}
                                                                onChange={() => setaccept(!accept)}
                                                            />
                                                            <label className="custom-control-label" htmlFor="tyc">
                                                                Acepto la <span className='text-primary ms-1 text-underline fw-bold' onClick={() => setshow(true)}>Política de Datos Personales</span>
                                                            </label>
                                                        </div>
                                                        {errors.hasOwnProperty('accept') && 
                                                            <div className='small text-primary fw-bold pt-2 pb-3' style={{fontSize: '.6em'}}>
                                                                {errors.accept ? errors.accept : ""}
                                                            </div>
                                                        }
                                                        <div className="text-center pt-4">
                                                            <button 
                                                                disabled={sending} 
                                                                type='submit' 
                                                                className='btn btn-primary px-5 fw-bold'
                                                            >
                                                                {sending ? "Enviando..." : "Registrarse"}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {slugNotFound && <Redirect to={`/evento-no-encontrado`} />}

                    {/* 
                        {success && <Redirect to={`/registro/${slug}/resultado`} />}
                    */}
                </section>

            </div>
        )
    }else if(!loading && success){

        /*
            let renderCalendar = btnCalendar.search("Add to Calendar");
            console.log(renderCalendar);

            if(renderCalendar > 0){
                renderCalendar = btnCalendar.replace('Add to Calendar', `<span className="btn px-4 fw-bold btn-info">Agregar al calendario</span>`);
            }else{
                renderCalendar = btnCalendar;
            }
        */

        return (
            
            <section className="formulario registro mt-4">
                <div className="content">
                    <div className="container">
                        <div className="row justify-content-center vh-50">
                            <div className="col-lg-7 d-flex align-items-center">
                                <div className="form-content w-100 card py-5 shadow">
                                        <div className="text-center mb-5">
                                            <i className="fa-regular fa-circle-check fa-5x text-primary"></i>
                                        </div>

                                        <h2 className='title mb-4'>¡Registro exitoso!</h2>
                                        <p className='subtitle pb-4 w-50 mx-auto f-normal'>
                                            Ya puedes acceder a {event.even_Nombre ? event.even_Nombre : event.Even_Nombre}
                                        </p>

                                        <div className='d-flex justify-content-center data-date mb-4'>
                                            <h4 className='mb-0 h6'>
                                                <i className="fa-regular fa-calendar text-primary me-2"></i>
                                                <span className='fw-bold'>{moment(event.even_FechaInicio).format('D [de] MMMM [de] YYYY')}</span>
                                            </h4>
                                            <div className="vertical-divider"></div>
                                            <h4 className='mb-0 h6'>
                                                <i className="fa-regular fa-clock text-primary me-2"></i>
                                                <span className='fw-bold'>{moment(event.even_FechaInicio).format('HH:mm [h]')}</span>
                                            </h4>
                                        </div>

                                        {/* 
                                            <form onSubmit={e => {
                                                e.preventDefault();
                                                atcb_action({
                                                    name:           event.even_Nombre,
                                                    description:    event.even_Descripcion,
                                                    startDate:      moment(event.even_FechaInicio).format('yyyy-MM-DD'),
                                                    endDate:        moment(event.even_FechaFin).format('yyyy-MM-DD'),
                                                    options:        ['Google'],
                                                    // timeZone: "Europe/Berlin",
                                                    iCalFileName: "Reminder-Event",
                                                });
                                                }}>
                                        

                                                <div className="text-center">
                                                    <button type='submit' className='btnaddcalendar btn px-4 shadow-sm'>
                                                        <i className="fa-regular fa-calendar me-3"></i>
                                                        <span className='fw-bold'>Agregar al calendario</span>
                                                    </button>
                                                </div>
                                            </form>
                                        */}

                                        

                                        <div 
                                            className='text-center' 
                                            dangerouslySetInnerHTML={{__html: btnCalendar}} 
                                        />

                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }else{
        return (
            <Loader full />
        )
    }
}

export default FormRegister